module.exports = __webpack_public_path__ + "static/img/1@2x (2).0e3b472.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/1@2x (2).png
// module id = K4dN
// module chunks = 1